<ng-container *ngFor="let item of items; trackBy: trackByFn">
  <ng-run-solution-tree-item [item]="item"></ng-run-solution-tree-item>
  <ng-run-solution-tree [curItem]="item" [files]="files"></ng-run-solution-tree>
</ng-container>
